<template>
  <div class="menu-wrapper">
    <template v-for="item in rotesList" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow"
        :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="$route.path==(item.path+'/'+item.children[0].path)?(item.children[0].meta.icon+'_active'):item.children[0].meta.icon">
          </svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title"
            slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0"
            :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
import {currentMall} from "../../../../api/mall";

export default {
  name: 'SidebarItem',
  data(){
    return{
      rotesList:[]
    }
  },
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.rotesList=this.routes;
    // currentMall().then(res => {
    //   if (res.data.mallStatus!=20){
    //     this.rotesList=this.routes.map((d,i)=>{
    //       if ( typeof (d.meta) =="undefined"){
    //         return d;
    //       }
    //        if(d.meta.navId==1||d.meta.navId==2){
    //          d.hidden=false;
    //        }else{
    //          d.hidden=true;
    //        }
    //        if(res.data.mallStatus == 0){
    //
    //          console.log([9,10,11].indexOf(d.meta.navId))
    //          if([9,10,11].indexOf(d.meta.navId)>-1){
    //            d.hidden=false;
    //          }
    //        }
    //        console.log(d)
    //       return d;
    //     })
    //   }else{
    //     this.rotesList=this.routes;
    //   }
    // })

  },
  methods: {
    hasOneShowingChildren (children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue